import styled from 'styled-components';

export default {
  Text: styled.span,
  Image: styled.img,
  View: styled.div,
  Button: styled.button,
  styled,
  mainColor: '#724f42',
  plain: {
    Text: styled.span``,
    Image: styled.image``,
    View: styled.div``,
    Button: styled.button``,
  }
};
